<div [ngClass]="{ 'card' : !empty }">
  <div [ngClass]="{ 'card-body p-4' : !empty }">
    <pane></pane>
  </div>
</div>